import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface GeoAddressError {
  municipalityName?: string;
  departmentName?: string;
  distanceMeters?: number;
}

@Component({
  selector: 'app-geo-validation-feedback',
  templateUrl: './geo-validation-feedback.component.html',
  styleUrls: ['./geo-validation-feedback.component.scss']
})
export class GeoValidationFeedbackComponent {
  @Input() validating = false;
  @Input() error: GeoAddressError | null = null;
  @Input() showEditButton = false;
  @Output() editAddress = new EventEmitter<void>();
}
